import { MessageCircle } from 'lucide-react';

/**
 * discover-chrome-density — « ouvre la conversation », dans la rangée d'actions.
 *
 * Il était un SIGNAL sous le commentaire de l'auteur — « il y a une discussion
 * ici » — et disparaissait à zéro réponse. Deux raisons de le déplacer :
 *
 *  1. sous le commentaire, il coûtait 40 pt à une carte qui débordait par le
 *     haut au point de rogner la pochette ;
 *  2. disparaître à zéro fermait une boucle : sans CTA, personne ne pouvait
 *     écrire la première réponse depuis le feed, donc le compteur restait à
 *     zéro, donc le CTA n'apparaissait jamais.
 *
 * `reco-comment-replies` avait écarté « 💬 au même niveau que les emojis », et
 * ce n'est pas ce qui se passe ici : la rangée d'actions ne contient aucune
 * réaction. `😊+` n'en est pas une — c'est le bouton qui ouvre leur choix. Deux
 * points d'entrée voisins, aucun des deux n'est une donnée de l'utilisateur.
 */
const MAX_SHOWN = 99;

export default function DiscussionCount({
  count,
  onOpen,
  label,
}: {
  /** Réponses en attente dans le cercle regardé. 0 = aucune, le CTA reste. */
  count: number;
  onOpen: () => void;
  /** Libellé accessible. */
  label: string;
}) {
  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label={label}
      data-testid="discussion-count"
      className="tw:relative tw:flex tw:size-[58px] tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full tw:btn-circle tw:text-white tw:transition-opacity tw:active:opacity-70"
    >
      <MessageCircle size={22} aria-hidden="true" />
      {count > 0 && (
        <span
          data-testid="discussion-count-badge"
          // Plafonnée : « 99+ » borne la largeur, donc la rangée d'actions ne
          // bouge pas le jour où une reco s'emballe.
          className="tw:absolute tw:-right-0.5 tw:-top-0.5 tw:flex tw:min-w-5 tw:items-center tw:justify-center tw:rounded-full tw:bg-blue-primary tw:px-1 tw:text-[11px] tw:font-semibold tw:text-white"
        >
          {count > MAX_SHOWN ? `${MAX_SHOWN}+` : count}
        </span>
      )}
    </button>
  );
}
